import apiClient from './apiClient';

const sectionServices = {
    fetchSections: async () => {
        try {
            const response = await apiClient.get('/sections.php?action=getSections');
            return response.data;
        } catch (error) {
            console.error('Errore nel recupero delle sezioni:', error);
            throw error;
        }
    },

    addSection: async (section) => {
        try {
            const response = await apiClient.post('/sections.php?action=addSection', section);
            return response.data;
        } catch (error) {
            console.error('Errore nell\'aggiunta della sezione:', error);
            throw error;
        }
    },

    updateSection: async (id, section) => {
        try {
            const response = await apiClient.put(`/sections.php?action=updateSection&id=${id}`, section);
            return response.data;
        } catch (error) {
            console.error('Errore nell\'aggiornamento della sezione:', error);
            throw error;
        }
    },

    removeSection: async (id) => {
        try {
            const response = await apiClient.delete(`/sections.php?action=removeSection&id=${id}`);
            return response.data;
        } catch (error) {
            console.error('Errore nella rimozione della sezione:', error);
            throw error;
        }
    },
};

export default sectionServices;
